import { render, staticRenderFns } from "./GoodsGroupSettingSelector.vue?vue&type=template&id=b4418998&scoped=true&"
import script from "./GoodsGroupSettingSelector.vue?vue&type=script&lang=js&"
export * from "./GoodsGroupSettingSelector.vue?vue&type=script&lang=js&"
import style0 from "./GoodsGroupSettingSelector.vue?vue&type=style&index=0&id=b4418998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4418998",
  null
  
)

export default component.exports